export const PAGE_DROPDOWN_FOR_ROLE_ACCESS_lIST = 'PAGE_DROPDOWN_FOR_ROLE_ACCESS_lIST'
export const PAGE_DROPDOWN_FOR_ROLE_ACCESS_lIST_SUCCESS = 'PAGE_DROPDOWN_FOR_ROLE_ACCESS_lIST_SUCCESS'

export const GET_ROLE_ACCESS_LIST_FOR_ROLE_ACCESS_lIST_PAGE = 'GET_ROLE_ACCESS_LIST_FOR_ROLE_ACCESS_lIST_PAGE'
export const GET_ROLE_ACCESS_LIST_FOR_ROLE_ACCESS_lIST_PAGE_SUCCESS = 'GET_ROLE_ACCESS_LIST_FOR_ROLE_ACCESS_lIST_PAGE_SUCCESS'

export const SAVE_ROLE_ACCESS_ADD_ACTION = 'SAVE_ROLE_ACCESS_ADD_ACTION'
export const SAVE_ROLE_ACCESS_ADD_ACTION_SUCCESS = 'SAVE_ROLE_ACCESS_ADD_ACTION_SUCCESS'

export const GET_ROLEACCESS_LIST_PAGE = 'GET_ROLEACCESS_LIST_PAGE'
export const GET_ROLEACCESS_LIST_PAGE_SUCCESS = 'GET_ROLEACCESS_LIST_PAGE_SUCCESS'

export const SAVE_COPY_ROLE_ACCESS_ACTION = 'SAVE_COPY_ROLE_ACCESS_ACTION'
export const SAVE_COPY_ROLE_ACCESS_ACTION_SUCCESS = 'SAVE_COPY_ROLE_ACCESS_ACTION_SUCCESS'

export const DELETE_ROLE_ACCESS_lIST = 'DELETE_ROLE_ACCESS_lIST'
export const DELETE_ROLE_ACCESS_lIST_SUCCESS = 'DELETE_ROLE_ACCESS_lIST_SUCCESS'

export const UPDATE_ROLE_ACCESS_lIST = 'UPDATE_ROLE_ACCESS_lIST'
export const UPDATE_ROLE_ACCESS_lIST_SUCCESS = 'UPDATE_ROLE_ACCESS_lIST_SUCCESS'

export const EDIT_ROLE_ACCESS_lIST = 'EDIT_ROLE_ACCESS_lIST'
export const EDIT_ROLE_ACCESS_lIST_SUCCESS = 'EDIT_ROLE_ACCESS_lIST_SUCCESS'

export const GO_BUTTON_HANDLER_FOR_ROLE_ACCESS_lIST_PAGE = 'GO_BUTTON_HANDLER_FOR_ROLE_ACCESS_lIST_PAGE'

export const ADD_PAGE_HANDLER_FOR_ROLE_ACCESS_lIST_PAGE = 'ADD_PAGE_HANDLER_FOR_ROLE_ACCESS_lIST_PAGE'


export const SET_TABLE_DATA_ROLE_ACCSS_ADD_PAGE_SUCCESS = 'SET_TABLE_DATA_ROLE_ACCSS_ADD_PAGE_SUCCESS'


export const ROLE_ACCESS_API_ERROR_ACTION = 'ROLE_ACCESS_API_ERROR_ACTION'

